import {
  STAGED,
  STAGE_PENDING,
  STAGE_IN_PROGRESS,
  PICK_PENDING,
  PICK_IN_PROGRESS,
  STOWED,
  STOW_PENDING,
} from "./EntityStatusManager";

//Route Status Table Headers
export const ROUTE_CODE = "Route code";
export const DISPATCH_TIME = "Dispatch time";
export const ROUTE_ID = "Route ID";
export const LOCATION = "Location";
export const STAGE_TIME = "Stage time";
export const DRIVER_TYPE = "Driver type";
export const PROGRESS = "Progress";
export const ASSOCIATE = "Associate";
export const DURATION = "Duration";
export const SPEED = "Speed";
export const STAGE_BY_TIME = "Stage by time";
export const STATUS = "Status";
export const MIN_IN_STATUS = "Min in status";
export const COLLAPSE_TABLE = "Collapse table";
export const EXPAND_TABLE = "Expand table";
export const CLEAR_ALL = "CLEAR ALL";
export const PICKLISTS = "Picklists";
export const ROUTES = "Routes";
export const CLUSTER = "Cluster";
export const LOCATION_TYPE = "Location type";
export const OVERFLOW = "Overflow";
export const DELIVERY_SPEED = "Delivery speed";
export const ROUTE_STATUS = "ROUTE_STATUS";
export const EXPORT_TO_CSV = "Export To CSV";
export const START_TIME = "Start time";
export const END_TIME = "End time";
export const ROUTE_DETAILS = "Route Details";
export const ASSOCIATE_DETAILS = "Associate Details";
export const AVERAGE_STAGE_DURATION = "Average Stage Duration";
export const PICKLIST_TYPE = "Picklist Type";

// Export CSV Columns Header
export const ROUTE_STATUS_EXPORT_CSV_TABLE_COLUMNS = [
  ROUTE_CODE,
  DISPATCH_TIME,
  ROUTE_ID,
  LOCATION,
  STATUS,
  PROGRESS,
  ASSOCIATE,
  STAGE_TIME,
  DURATION,
  DRIVER_TYPE,
  SPEED,
];

export const ROUTE_SPEED = {
  RUSH_1_HR: "RUSH_1_HR",
  RUSH_3_HR: "RUSH_3_HR",
  STANDARD: "STANDARD",
};

export const ROUTE_SPEED_LABELS = {
  ONE_HOUR: "1h",
  THREE_HOUR: "3h",
  STANDARD_SPEED: "Standard",
};

export const SSD = "SSD";
export const FALLBACK_DASH = "-";
export const FALLBACK_ELLIPSIS = "...";

export const ROUTE_PICKLIST_PROGRESS = {
  [STAGED]: "stageProgress",
  [STAGE_PENDING]: "stageProgress",
  [STAGE_IN_PROGRESS]: "stageProgress",
  [PICK_PENDING]: "pickProgress",
  [PICK_IN_PROGRESS]: "pickProgress",
  [STOWED]: "stowProgress",
  [STOW_PENDING]: "stowProgress",
};

// Filter Field Constants
export const CLUSTER_FILTER = "cluster";
export const ROUTE_CODE_FILTER = "routeCode";
export const DRIVER_TYPE_FILTER = "driverType";
export const DEPARTURE_FILTER = "departure";
export const ROUTE_SLA_FILTER = "routeSLA";
export const STATUS_FILTER = "status";
export const ROUTE_STATUS_FILTER = "routeStatus";
export const DELIVERY_SPEED_FILTER = "deliverySpeed";
export const ROUTE_SPEED_FILTER = "routeSpeed";
export const DRIVER_FILTER = "driver";
export const STAGE_DURATION_FILTER = "stageDuration";



// WEBPACK FOOTER //
// ./src/components/RouteStatus/utils/Constants.js